import { IUser, SpotifyAuthState } from "@/interface";
import { spotifyApi } from "@/services/spotify";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

const initialState: SpotifyAuthState = {
    accessToken: null,
    refreshToken: null,
    expiresIn: null,
    status: "empty",
    user: {
        id: "",
        country: "",
        display_name: "",
        email: "",
        href: "",
        images: [],
        type: "",
        uri: "",
        product: "",
    },
    isAuthenticated: false,
    isGuest: false,
}

export const userLogin = createAsyncThunk(
    'spotifyAuth/userLogin',
    async () => {
        const response = await spotifyApi.getMe()
        return response.body
    }
);

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAccessToken: (state: SpotifyAuthState, action: PayloadAction<string>) => {
            state.accessToken = action.payload;
        },
        setAuthenticated: (state: SpotifyAuthState, action: PayloadAction<boolean>) => {
            state.isAuthenticated = action.payload;
        },
        setIsGuest: (state: SpotifyAuthState, action: PayloadAction<boolean>) => {
            state.isGuest = action.payload;
        },
        clearAuthAll: (state: SpotifyAuthState) => {
            state.isGuest = false;
            state.isAuthenticated = false;
            state.accessToken = null;
            state.refreshToken = null;
            state.expiresIn = null;
            state.user = {} as IUser;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(userLogin.pending, (state) => {
            state.status = "loading";
        })
        builder.addCase(userLogin.rejected, (state) => {
            state.status = "failed";
            state.isAuthenticated = false;
        })
        builder.addCase(userLogin.fulfilled, (state, action) => {
            state.user = action.payload as IUser;
            state.status = "ok";
        })
    }
});

export const { setAccessToken, setAuthenticated, setIsGuest, clearAuthAll } = authSlice.actions;

export const SelectAuth = (state: RootState) => state.auth;


export default authSlice.reducer